import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StudentService } from "../studentService";
import { WidgetFrame } from "../../../personal-studio-components/studio";
import { ErrataWidget } from "../../../personal-studio-components/studio";
import * as cls from "./promo.module.scss";

function isSafeLink(raw) {
  const v = String(raw || "").trim();
  if (!v) return false;
  if (v.startsWith("/")) return !v.startsWith("//") && !v.includes("\\");
  try {
    const u = new URL(v);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

export default function Promo({ menu }) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    StudentService.send(
      {
        method: "post",
        path: "/student/widget/promo",
        data: { access_token, study_contract_id: contractId },
      },
      setResponse,
    );
  }, [access_token, contractId]);

  if (!response) return null;
  if (response.errors) return <ErrataWidget errata={response} />;

  const src = response.source ?? response;
  if (!src.image) return null;

  const alt = src.title || src.text || "Баннер";
  const banner = (
    <div
      className={cls.promo}
      role="img"
      aria-label={alt}
      style={{ backgroundImage: `url("${src.image}")` }}
    >
      {src.text && <div className={cls.promoText}>{src.text}</div>}
    </div>
  );

  return (
    <WidgetFrame type="blue" title="" menu={menu} className={cls.promoFrame}>
      <div className={cls.promoBody}>
        {isSafeLink(src.link) ? (
          <a
            href={src.link}
            target="_blank"
            rel="noopener noreferrer"
            className={cls.promoLink}
          >
            {banner}
          </a>
        ) : (
          banner
        )}
      </div>
    </WidgetFrame>
  );
}
